import { render, staticRenderFns } from "./Fixedassetsinventory.vue?vue&type=template&id=571fc567&scoped=true&"
import script from "./Fixedassetsinventory.vue?vue&type=script&lang=js&"
export * from "./Fixedassetsinventory.vue?vue&type=script&lang=js&"
import style0 from "./Fixedassetsinventory.vue?vue&type=style&index=0&id=571fc567&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571fc567",
  null
  
)

export default component.exports